module.exports = "/_next/static/images/game-race-dc2b6775b8f38ea27d64068b1cc0f929.png";